/**
 *
 * MenuItem
 *
 */

import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import _some from 'lodash/some';
// styles
import './Menu.scss';
import CONSTANTS from './Menu.constants';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRight from '@material-ui/icons/ArrowRight';

function MenuItem({ isMobile, handleLogout, ...props }) {
  const [toggleSubMenu, setToggleSubMenu] = useState({});
  const { location } = props || {};
  const isCurrentUrl = (path) => {
    return location === path;
  };

  useEffect(() => {
    const SUB_MENU_ITEMS = CONSTANTS.MENU_ITEMS.filter((item) => item?.SUB_MENU?.length);
    const SUB_MENUS = SUB_MENU_ITEMS.reduce((acc, menu) => {
      return [
        ...acc,
        ...menu.SUB_MENU.map((subMenu) => {
          return { ...subMenu, parentId: menu.ID };
        }),
      ];
    }, []);
    const ACTIVE_SUB_MENUS = SUB_MENUS.filter((menu) => menu.PATH === location);
    if (ACTIVE_SUB_MENUS?.length) {
      const ACTIVE_SUB_MENU_IDS = ACTIVE_SUB_MENUS.reduce((acc, subMenu) => {
        return {
          ...acc,
          [subMenu.parentId]: true,
        };
      }, {});
      setToggleSubMenu(ACTIVE_SUB_MENU_IDS);
    } else {
      setToggleSubMenu({})
    }
  }, [location]);

  const toggleDropdown = useCallback(
    (id) => {
      setToggleSubMenu((prevState) => {
        return {
          ...prevState,
          [id]: !prevState[id] ? true : false,
        };
      });
    },
    [setToggleSubMenu],
  );

  return (
    <div>
      {CONSTANTS.MENU_ITEMS.map((item, index) =>
        item.NAME === 'Logout' ? (
          isMobile ? (
            <div key={`${item.NAME}_${index}`} className={'menu-item-wrapper '} onClick={() => handleLogout()}>
              <div className="item-image-wrapper"></div>
              <div className="name logout">{item.NAME}</div>
            </div>
          ) : null
        ) : item.SUB_MENU && item.SUB_MENU.length ? (
          <>
            <div key={`${item.ID}_${index}`}>
              <div onClick={() => toggleDropdown(item.ID)} className="menu-item-wrapper">
                <div className="item-image-wrapper">
                  <img src={isCurrentUrl(item.PATH) ? item.ACTIVE : item.INACTIVE} alt={item.NAME} />
                </div>
                <div className="name">{item.NAME}</div>
                {toggleSubMenu[item.ID] ? (
                  <ArrowDropDownIcon key={`arrowdown_${item.ID}_${index}`} className="menu-item-wrapper-icon" />
                ) : (
                  <ArrowRight key={`arrow_${item.ID}_${index}`} className="menu-item-wrapper-icon" />
                )}
              </div>
            </div>
            {toggleSubMenu[item.ID] && (
              <>
                <ArrowDropDownIcon key={`arrowdownopened_${item.ID}_${index}`}  className="menu-item-wrapper-icon-down" />
                <div className="subMenu">
                  {item.SUB_MENU.map((subItem, subIndex) => (
                    <Link key={`${subItem.PATH}_${index}_${subIndex}`} to={subItem.PATH}>
                      <div className={'menu-item-wrapper ' + (isCurrentUrl(subItem.PATH) ? 'selected' : '')}>
                        <div className="item-image-wrapper">
                          <img
                            src={isCurrentUrl(subItem.PATH) ? subItem.ACTIVE : subItem.INACTIVE}
                            alt={subItem.NAME}
                          />
                        </div>
                        <div className="name">{subItem.NAME}</div>
                      </div>
                    </Link>
                  ))}
                </div>
              </>
            )}
          </>
        ) : (
          <Link key={`${item.PATH}_${index}`} to={item.PATH}>
            <div className={'menu-item-wrapper ' + (isCurrentUrl(item.PATH) ? 'selected' : '')}>
              <div className="item-image-wrapper">
                <img src={isCurrentUrl(item.PATH) ? item.ACTIVE : item.INACTIVE} alt={item.NAME} />
              </div>
              <div className="name">{item.NAME}</div>
            </div>
          </Link>
        ),
      )}
    </div>
  );
}

export default MenuItem;
